import { type SimilarProduct } from './aliases';

import { SIMILAR_ITEMS_SASH_PRODUCTS_COUNT } from '@/modules/similar/constants';

export function getSimilarSashAndYMALProducts(
  products: SimilarProduct[],
  isSimilarSashVisible: boolean,
  colourId?: string,
  count?: number
) {
  let similarSash: SimilarProduct[] = [];
  let youMightAlsoLike: SimilarProduct[] = [];

  const similarSashCount = count ?? SIMILAR_ITEMS_SASH_PRODUCTS_COUNT;

  if (!isSimilarSashVisible) {
    return { similarSash, youMightAlsoLike: products };
  }

  if (colourId) {
    const colourMatches = products.filter(
      (product) => product.attributes?.colour?.[0] === colourId
    );
    const colourMatchedSash = colourMatches.slice(0, similarSashCount);
    const colourMatchesCount = colourMatchedSash.length;

    if (colourMatchesCount > 0) {
      if (colourMatchesCount < similarSashCount) {
        const usedIds = new Set(colourMatchedSash.map((p) => p.id));
        const padding = products
          .filter((p) => !usedIds.has(p.id))
          .slice(0, similarSashCount - colourMatchesCount);
        similarSash = [...colourMatchedSash, ...padding];
      } else {
        similarSash = colourMatchedSash;
      }

      const usedIds = new Set(similarSash.map((p) => p.id));
      youMightAlsoLike = products.filter((p) => !usedIds.has(p.id));
      return { similarSash, youMightAlsoLike, colourMatchesCount };
    }
  }

  if (products.length < SIMILAR_ITEMS_SASH_PRODUCTS_COUNT) {
    youMightAlsoLike = products;
    return { similarSash, youMightAlsoLike };
  }

  similarSash = products.slice(0, similarSashCount);
  youMightAlsoLike = products.slice(similarSashCount);

  return { similarSash, youMightAlsoLike };
}
